"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Form = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var styles = {
  "Form": "Form__Form___2zwZf",
  "Form__item": "Form__Form__item___2qOZE",
  "Form__item--default": "Form__Form__item--default___1CHMK",
  "Form__item--condensed": "Form__Form__item--condensed___2iooB"
};
var defaultProps = {
  spacing: 'default',
  testId: 'cf-ui-form'
};

var Form = function Form(props) {
  var className = props.className,
      children = props.children,
      testId = props.testId,
      onSubmit = props.onSubmit,
      spacing = props.spacing,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["className", "children", "testId", "onSubmit", "spacing"]);
  var classNames = (0, _classnames["default"])(styles.Form, className);
  var formItemClassNames = (0, _classnames["default"])(styles.Form__item, styles["Form__item--".concat(spacing)]);
  var handleSubmit = (0, _react.useCallback)(function (event) {
    event.preventDefault();

    if (onSubmit) {
      onSubmit(event);
    }
  }, [onSubmit]);
  return /*#__PURE__*/_react["default"].createElement("form", (0, _extends2["default"])({
    className: classNames,
    "data-test-id": testId,
    onSubmit: handleSubmit
  }, otherProps), _react.Children.map(children, function (child) {
    if (child) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: formItemClassNames
      }, child);
    }

    return null;
  }));
};

exports.Form = Form;
Form.defaultProps = defaultProps;
var _default = Form;
exports["default"] = _default;